<template>
	<!-- Begin Page Content -->
        <div class="container" v-if="school && teacher">
          <div class="row justify-content-between">
            <div class="col text-center">
              <h3 class="h3 mb-2 text-gray-800">Багшийн заах хичээлүүд</h3>
              <h5 class="h5 mb-2 text-gray-800" v-if="teacher">{{teacher.name}} / {{teacher.code}} / {{teacher.email}}</h5>
              <span class="text-danger">{{teacherPath}}</span>
            </div>
          </div>
            <table class="table table-sm table-responsive-md">
              <tr style="border:2px solid black;">
                <th >Ээлж</th>
                <th style="border-left:2px solid black;">Цаг&nbsp;&nbsp;&nbsp;&nbsp;</th>
                <th v-for="day in weekNumbers" class="p-0 schedule-cell" style="border-left:1px solid black!important;">
                  <span v-if="day==1">Даваа</span>
                  <span v-if="day==2">Мягмар</span>
                  <span v-if="day==3">Лхагва</span>
                  <span v-if="day==4">Пүрэв</span>
                  <span v-if="day==5">Баасан</span>  
                </th>
              </tr>
              <tbody v-for="line in lines" style="border:2px solid black;">
                <tr v-for="(time, index) in times">
                  <td v-if="index==0" :rowspan="times.length" style="vertical-align:middle;" class="text-primary font-weight-bold text-center">{{line}} ээлж</td>
                  <td style="border-left:2px solid black;">
                    {{time}}-р цаг
                    <span class="font-weight-bold text-primary" v-if="line && time"><br/>{{isIn(line+'-'+time)}}</span>
                  </td>
                  <td v-for="day in weekNumbers" class="p-0 schedule-cell" style="border-left:1px solid black!important;vertical-align:middle;text-align:center">
                    <div v-if="_getTimeObject(day,line,time) && _getTimeObject(day,line,time).length>0">
                      <div v-for="p in _getTimeObject(day,line,time)" class="text-primary" @click="goLessonDetail(p)" style="cursor:pointer">
                        <span v-if="p.programData">
                          <span v-if="p.departmentData">{{p.departmentData.name}}/</span>
                          {{p.programData.name}}
                        </span>
                        <span v-if="p.groupData" class="text-primar font-weight-bold">
                          {{splitName(p.groupData.name)}}
                        </span>
                        <span v-if="p.lessonData && (!showSimple)">  - {{p.lessonData.name}}</span>
                      </div>
                    </div>
                    <div v-else @click="askSchedule(line , time, day)">&nbsp;</div>
                  </td>
                </tr>
              </tbody> 
            </table>
       
		 
          <!-- DataTales Example -->
          <div class="card shadow my-4" v-for="(semester) in semesters" v-bind:key="semester.id">
            <div class="card-header row m-0">
              <div class="col">
                <h4>{{semester.title}}</h4>
              </div>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-bordered table-striped table-responsive-md" id="dataTable" width="100%" cellspacing="0" v-if="semester.lessons!=null && semester.lessons.length>0">
                  <thead>
                    <tr>
                      <th>№</th>
                      <th style="width: 28%">Нэр</th>
                      <th>Анги</th>
                      <th>Төрөл</th>
                      <th>Ангиар/Группээр</th>
                      <th>Мэдээлэл</th>
                      <th>Нээлттэй эсэx</th>
                      <th>Үйлдэл</th>
                    </tr>
                  </thead>

                  <tbody>
					          <tr v-for="(lesson, index) in semester.lessons" v-bind:key="lesson.id">
                      <td>{{index+1}}</td>
                      <td>{{lesson.name}}</td>
                       <td>
                          <p v-if="lesson.departmentDatas && lesson.departmentDatas.length>0" v-for="dep in lesson.departmentDatas">{{dep.name}} анги</p>
                      </td>
                      <td>
                          <span class="badge badge-success" v-if="lesson.categoryType=='zaaval'">{{lesson.categoryName}}</span>
                          <span class="badge badge-warning" v-else>{{lesson.categoryName}}</span>
                      </td>
                      <td>
                          <span v-if="lesson.isGroup" class="badge badge-danger">группээр</span>
                          <span v-else class="badge badge-primary">ангиар</span>     
                      </td>
                      <td>
                        <div v-if="lesson.numberOfStudents">Сурагч: {{lesson.numberOfStudents}}</div>
                        <div v-if="lesson.numberOfTopics">Сэдэв: {{lesson.numberOfTopics}}</div>
                        <div v-if="lesson.numberOfVideos">Видео хичээл: {{lesson.numberOfVideos}}</div>
                        <div v-else class="text-danger">видео оруулаагүй</div>
                      </td>
                      <td>
                        <h6 v-if="lesson.published==true" style="cursor:pointer"><span class="badge badge-success">Нээлттэй</span></h6>
                        <h6 v-else style="cursor:pointer"><span class="badge badge-danger" >Хаалттай</span></h6>
                      </td>
                      <td>
                 
                          <button class="btn  btn-primary btn-sm mx-1" @click="goDetail(lesson)">хараx</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="alert alert-info text-center">Та {{semester.title}} семестерт ямар нэгэн хичээл оруулаагүй байна.</div>
              </div>
            </div>
          </div>

    <!-- Modal -->
      <div class="modal fade" id="schedulModal" tabindex="-1" role="dialog" aria-labelledby="schedulModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="scheduleModalLabel">Хуваарь нэмэх</h5>
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p class="text-center text-primary">{{cweekday}} өдрийн {{cline}} ээлжийн {{ctime}} цаг дээр орох хичээлээ сонгоно уу</p>
              <div>
                <table class="table table-sm table-bordered">
                  <tbody>
                  <tr v-for="pro in lessons" >
                    <td>
                      <div @click="goAddSchedule(pro, cline , ctime, cweekday)" 
                        style="cursor:pointer;font-size:14px;" 
                        class="badge badge-success px-3 py-2 mr-2 my-2" 
                      >
                        {{pro.name}} <span v-if="pro && pro.classNos && pro.classNos.length>0"> - {{pro.classNos[0]}} анги</span>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
         
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
            </div>
          </div>
        </div>
      </div>
  </div>
        <!-- /.container-fluid -->
</template>

<script>
const fb = require('../../../firebaseConfig.js')
import Vue from 'vue'
import { mapState } from "vuex";
import { currentUser } from '../../../firebaseConfig.js';
import timetable from '../shared/timetable.js';
import moment from 'moment'
export default {
  name: "TeacherLessons",
  data() {
    return {
      msg: "Hellow",
      lessons: [],
      trending:{
        content:[]
      },
      semesters:[],
      copyLesson:null,
      copySemester:null,
      school:null,
      department:null,
      teacher:null,
      pros:[],
      lines:[1, 2],
      times:[1, 2, 3, 4, 5, 6, 7],
      weekNumbers:[1,2,3,4,5],
      showSimple:true,
      cline:null,
      ctime:null,
      cweekday:null,
      
    };
  },
  mixins:[timetable],
  computed: {
    ...mapState(["currentUser"])
  },
  props:{
    teacherPath:{
      required:true
    },
    schoolId:{
      required:true
    }
  },
  created() {
    if(this.teacherPath)
      this._getLessons();
    
  },
   methods: {
      _getLessons(){
		  var _this = this;
      var vm = this;
      this._getTimeTables('/schools/'+this.schoolId+'/timetable');
      fb.db.collection("schools").doc(this.schoolId).get().then(schoolDoc=>{
        if(schoolDoc.exists){
          let school=schoolDoc.data();
          school.id=schoolDoc.id;
          this.school=school;
          fb.db.doc(this.teacherPath).get().then(teacherDoc=>{
            if(teacherDoc.exists){
              let teacher=teacherDoc.data();
              teacher.id=teacherDoc.id;
              this.teacher=teacher;

              let object={id:null, name:'Хичээлүүд'};
              object.lessons=[];
              this.lessons=[];
              fb.db.collection("schools/"+this.schoolId+"/lessons")
                .where("teacher", "==", fb.db.doc(this.teacherPath)).orderBy("name")
                .get().then(querySnapshot1=> {
                object.lessons=[];
                querySnapshot1.forEach(lessonDoc=> {
                    let lesson=lessonDoc.data();
                    lesson.id = lessonDoc.id;
                    lesson.teachedBy=null;
                    lesson.departmentDatas=[];
                    if(lesson.departments && lesson.departments.length>0){
                        for(const department of lesson.departments){
                            if(department){
                                department.get().then(ddoc=>{
                                    if(ddoc.exists){
                                        lesson.departmentDatas.push(ddoc.data());
                                    }
                                })
                            }
                        }
                    }

                    if(lesson.teacher){
                      lesson.teacher.get().then(tdoc=>{
                        if(tdoc.exists){
                          lesson.teachedBy=tdoc.data();
                        }
                      });
                    }

                    
                    if(lesson.category){
                      lesson.category.get().then(tdoc=>{
                        if(tdoc.exists){
                          console.log(lesson.id, tdoc.data().typeDetail);
                          lesson.categoryType=tdoc.data().typeDetail.id;
                          lesson.categoryName=tdoc.data().typeDetail.name;
                          console.log(lesson);
                        }
                      });
                    }
                    object.lessons.push(lesson);
                    this.lessons.push(lesson);
                });
              });
              _this.semesters.push(object);
  
            }
          });
        }
      });


      fb.db.collectionGroup("lessonschedule").where("teacher", "==",fb.db.doc(this.teacherPath)).get().then(tdocs=>{
        this.pros=[];
        var i=0;
        tdocs.forEach(value=>{
          if(value.exists){
            let object=value.data();
            object.id=value.id;
            object.ref=value.ref;
            object.programData=null;
            object.departmentData=null;
            object.groupData=null;
            object.lessonData=null;
            object.index=i;
            if(object.lesson){
              object.lesson.get().then(ldoc=>{
                if(ldoc.exists){
                  object.lessonData=ldoc.data();
                }
              })
            }
            if(object.program)
            {
              object.program.get().then(pdoc=>{
                if(pdoc.exists){
                  object.programData=pdoc.data();
                  if(pdoc.ref.parent.parent){
                    pdoc.ref.parent.parent.get().then(ddoc=>{
                      object.departmentData=ddoc.data();
                    });
                  }
                }
              });
            }
            if(object.group)
            {
              object.group.get().then(pdoc=>{
                if(pdoc.exists){
                  object.groupData=pdoc.data();
              
                }
              });
            }

            this.pros.push(object);
          }
        });
        i++;
      });

      
      
    },
    askCopyLesson(lesson){
      var r = confirm("Та "+lesson.name+ " хичээлийг хуулахдаа итгэлтэй байна уу!!!");
      if (r == true) {
        this.copyLesson=lesson;
        $('#copyModal').modal('show');
      } 

    },

    goDetail(lesson){
      // if(lesson.isBlock!=true && (lesson.school==null || lesson.department==null || lesson.program==null)){
      //   alert("Та эхлээд хичээлийнхээ сургууль , тэнхим болон хөтөлбөрийг сонгоно уу");
      //   this.$router.push({ name: 'LessonEdit', params: { lessonId: lesson.id} });
      // }
      // else
        this.$router.push({ name: 'SLessonDetail', params: {schoolId: this.schoolId, lessonId: lesson.id} });
    },
    edit(lesson){
          this.$router.push({ name: 'ILessonAdd', params: { schoolId: this.schoolId ,lessonId: lesson.id, setTeacher:true} })
    },
    goLessons(classObject){
      this.$router.push({ name: 'SProgramLessons', params: { schoolId: classObject.school.id, departmentId: classObject.department.id, programId: classObject.id} })
    },
    _getTimeObject(day,line,time){
        var results=[];
        if(day && line && time){
          if(this.pros && this.pros.length>0){
            for(const schedule of this.pros){
              if(schedule && schedule.day==day && schedule.line==line && schedule.time==time){
                results.push(schedule);
              }
            }
          }
        }
        return results;
      },
    splitName(name){
      if(name && name.includes("/")){
        var n = name.indexOf("/");
        return name.substring(n, name.length).replaceAll('/','').replaceAll('-','/');
      }
      return name;
    },
    goLessonDetail(p){
      if(p && p.lesson && p.lesson.parent && p.lesson.parent.parent){
        this.$router.push({name:"SLessonDetail", params:{ schoolId: p.lesson.parent.parent.id, lessonId: p.lesson.id }});
      }
    },
    askSchedule(line , time, wkday){
      this.$confirm("Та "+wkday+" өдрийн "+line+" ээлжийн "+time+" цаг дээр хуваарь оруулах уу?").then(() => {
        this.cline=line;
        this.ctime=time;
        this.cweekday=wkday;
        $('#schedulModal').modal('toggle');
      });
    },
    goAddSchedule(lesson, line , time, weekday){
      $('#schedulModal').modal('toggle');
      this.$router.push({name:'ILessonSchedule', params:{schoolId: this.schoolId, lessonId: lesson.id, line: line, time:time, weekday: weekday}});
    },

	},
	filters: {
		formatDate(val) {
			if (!val) { return '-' }
			let date = val.toDate()
			return moment(date).fromNow()
		},
	
	}
};
</script>
<style scoped>
  .schedule-cell:hover {
    /* background-color:#f0f6ff; */
    background-color: #fff3cd;
    cursor:pointer
  }
</style>